import { FlagStates } from '@generated/graphql';
import type { ReconFlagSeverity } from './reconFlags.types';

export type ReconFlagsFilterValues = {
  severityTab: 'ALL' | ReconFlagSeverity;
  flagState: string;
  flagType: string | undefined;
  categoryFilter: string;
  agingFilter: string;
  search: string;
};

export const RECON_FLAGS_DEFAULT_FILTER_VALUES: ReconFlagsFilterValues = {
  severityTab: 'ALL',
  flagState: FlagStates.Flagged,
  flagType: undefined,
  categoryFilter: 'any',
  agingFilter: 'any',
  search: '',
};

export const hasReconFlagsActiveFilters = (
  filters: ReconFlagsFilterValues,
): boolean =>
  filters.severityTab !== RECON_FLAGS_DEFAULT_FILTER_VALUES.severityTab ||
  filters.flagState !== RECON_FLAGS_DEFAULT_FILTER_VALUES.flagState ||
  filters.flagType !== RECON_FLAGS_DEFAULT_FILTER_VALUES.flagType ||
  filters.categoryFilter !== RECON_FLAGS_DEFAULT_FILTER_VALUES.categoryFilter ||
  filters.agingFilter !== RECON_FLAGS_DEFAULT_FILTER_VALUES.agingFilter ||
  filters.search.trim() !== RECON_FLAGS_DEFAULT_FILTER_VALUES.search;
